var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"splashScreen loadingPage",staticStyle:{"opacity":"30%","z-index":"1500"},attrs:{"id":"loadingPage"}},[_c('img',{staticClass:"kovoLogo",class:{ 'inverted': _vm.isLightTheme },attrs:{"src":"/static/img/KovoLogoWhite.svg","alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }